// extracted by mini-css-extract-plugin
export var modalFooter = "_r8-0";